import { apiClient } from './apiClient';
import { IAppConfig } from '@/model/IAppConfig';
import { AppSingletonPromise } from './AppSingletonPromise';

class AppConfigService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getConfig(force = false): Promise<IAppConfig> {
    return apiClient.get('Configuration').then(response => {
      return response.data;
    });
  }
}

export const appConfigService = new AppConfigService();
